/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enteremailaddress2Inputs */

const en_enteremailaddress2 = /** @type {(inputs: Enteremailaddress2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter email address`)
};

const de_enteremailaddress2 = /** @type {(inputs: Enteremailaddress2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-Mail-Adresse eingeben`)
};

/**
* | output |
* | --- |
* | "Enter email address" |
*
* @param {Enteremailaddress2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const enteremailaddress2 = /** @type {((inputs?: Enteremailaddress2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enteremailaddress2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enteremailaddress2(inputs)
	return de_enteremailaddress2(inputs)
});
export { enteremailaddress2 as "enterEmailAddress" }